<template>
	<div class="menu-sorter">
		<ModalHeader
			no-new-line
			:title="getString('sort_menus', [userStore.menuWord])"
			:button-text="getString('save')"
			@click-button="saveSort" />
		<div class="sorter-container">
			<AppSortableList @sorted="changeListsOrder" full-width :hasAddItem="false" :items="listMenus"  key-prop="menu_id">
			</AppSortableList>
		</div>
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useMenuStore, useUserStore} from "@/console-new/stores";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppSortableList from "@/shared/components/AppSortableList.vue";
import API from "@/shared/helpers/API";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let menuStore = useMenuStore();
		let userStore = useUserStore();
		let notificationStore = useNotificationStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, menuStore, userStore};
	},
	name: "MenuSorter",
	components: {AppSortableList, AppButtonIcon, ModalHeader, AppBottomSheet},
	emits: ["close"],
	computed: {
		listMenus() {
			return Object.values(this.menuStore.menus).map(menu => {
				return {
					title: menu.name,
					menu_id: menu.menu_id + "",
					order_number: menu.order_number
				}
			}).sort((a, b) => {
				return a.order_number - b.order_number;
			});
		},
	},
	methods: {
		changeListsOrder(evt, newOrder) {
			for(let pos = 0; pos < newOrder.length; pos++) {
				if(newOrder[pos]) {
					let listProdTempId = Number(newOrder[pos].menu_id);
					this.menuStore.menus[listProdTempId].order_number = pos;
				}
			}
		},
		saveSort() {

			let menusFormatAPI = Object.values(this.menuStore.menus).map(menu => {
				return {
					menu_id: menu.menu_id,
					order_number: menu.order_number,
				}
			})
			API.init().updateMenusOrder(this.userStore.currBusinessId, menusFormatAPI, (resp) => {
				if(resp && resp.result === "OK") {
					this.showNotification("generic-success");
					this.$emit("close");
				} else {
					this.showNotification("generic-fail");
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">

</style>